import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const HomeButton: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {showHomeModal, setHomeModalOpen} =
    rootStore.responsiveStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    setHomeModalOpen(true);
  };

  return (
    <>
      <Button
        id="home"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 transparentButton toolbarButton",
        )}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="far fa-file-alt iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0">{t("toolbar_home_mobile")}</h6>
      </Button>
    </>
  );
};

export default observer(HomeButton);
